import React, {Component} from 'react';
import {Link, withRouteData} from 'react-static';
import styled from 'styled-components';

import logoSrc from '../resources/images/logo.svg';
import CookieDisclaimer from '../components/CookieDisclaimer';

const FooterStyle = styled.div`
	position: relative;
	padding: 15px 50px 10px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	
	.button {
		margin-left: 20px;
	}
	
	&.putBottom {
		position: absolute;
	    width: 100%;
	    bottom: 0;
	    
	    @media screen and (max-width: 63.9375em) {
	        position: relative;
		}
	}

	.footer-item {
		padding: 10px;
		font-weight: 400;
		display: inline-block;
		transition: color 100ms ease;
		font-size: 0.875rem;
		opacity: 0.5;
		&:hover {
			opacity: 1;
			color: #83F5F8;
		}
		@media screen and (max-width: 39.9375em) {
	        font-size: 1rem;
		}
	}
	
	.footer-logo {
		display: inline-block;
		width: 70px;
		height: 18px;
		background-position-x: 50%;
        background-position-y: center;
        background-repeat: no-repeat;
        background-size: contain;
		margin-right: 40px;
		vertical-align: middle;
		position: relative;
		top: -2px;
	}
	
	@media screen and (max-width: 39.9375em) {
		padding: 15px 20px 10px;
		
		.footer-logo {
			margin: 7px auto;
			display: block;
		}
    }

`;

class Footer extends Component {

	render() {
		return (
			<div>
				<div style={{paddingTop: this.props.bottom ? "80px" : ""}}>
					<FooterStyle className={this.props.bottom ? "putBottom" : ""}>
						<div className="footer-large">
							<div className="row expanded collapse">
								<div className="columns small-12 medium-6 medium-text-left text-center">
									<Link className="footer-logo" style={{ backgroundImage: `url(${logoSrc})` }} exact to={`${this.props.language === "" ? "" : "/"}${this.props.language}/`} />
									<Link className="footer-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/product`}>{ this.props.navigation.product }</Link>
									<Link className="footer-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/team`}>{ this.props.navigation.team }</Link>
									<Link className="footer-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/economy`}>{ this.props.navigation.economy }</Link>
								</div>
								<div className="columns small-12 medium-6 medium-text-right text-center">
									<a className="footer-item" target="_blank" href="/files/ctr_whitepaper.pdf">{ this.props.footer.whitepaper }</a>
									<Link className="footer-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/privacy-policy`}>{ this.props.footer.privacyPolicy }</Link>
									<Link className="footer-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/terms-of-service`}>{ this.props.footer.tos }</Link>
									<span className="footer-item">CTR {((new Date).getFullYear())} © All Rights Reserved</span>
								</div>
							</div>
						</div>
					</FooterStyle>
				</div>
				<CookieDisclaimer />
			</div>
		)
	}
}

export default withRouteData(Footer)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer.js